import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<defs><clipPath id=\"a\"><path fill-opacity=\".7\" d=\"M115.7 0h496.1v496h-496z\"></path></clipPath></defs><g fill-rule=\"evenodd\" stroke-width=\"1pt\" clip-path=\"url(#a)\" transform=\"translate(-119.5)scale(1.032)\"><path fill=\"#ff0\" d=\"M0 0h744v496H0z\"></path><path fill=\"#00ca00\" d=\"M0 0v496L496 0z\"></path><path fill=\"red\" d=\"M248 496h496V0z\"></path></g>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }